function checkRepeat (array, mark) {
  let obj = {}
  array = array.reduce((cur, next) => {
    obj[next[mark]] ? '' : (obj[next[mark]] = true && cur.push(next))
    return cur
  }, [])
  return array
}
export default checkRepeat



// WEBPACK FOOTER //
// ./src/utils/checkRepeat.js